import React, { useState } from 'react'
import ImageGallery from './ImageGallery';


function RecentWork() {

    const [projectNo, setProjectNo] = useState(-1)
    const [photoIndex, setPhotoIndex] = useState(0)
    const [isOpen, setIsOpen] = useState(false)

    const handleLigthBox = (index) => {
            console.log("index reached:", index)
            setProjectNo(index)
    }

    return (
        <>
            <div className="black" style={{minHeight: '60rem', position: 'absolute' ,width: '100%'}}>
            </div>
            <div className="container fluid">
                <div className="row pt-6">
                    <div className="col-sm-12">
                        <h5 className="center green-text text-darken-1 ff-mono">RECENT WORKS</h5>
                    </div>
                    <div className="col-sm-12 pt-4 ">
                        <h1 className="center white-text" style={{fontSize: '3.8rem'}}>
                            We love what we do, check out <br/> some of our latest works
                        </h1>
                    </div>
                    <div className="col-sm-12 col-md-6 offset-md-3">
                        <div className="pt-4 mt-4" style={{borderBottom: '1px solid #d3d3d3'}}></div>
                    </div>
                </div>

            </div>
            <div className="container">
            <div className="row">
                    <div className="col-sm-12">
                        <ImageGallery/>
                    </div>
                </div>
            </div>
       </>
    )
}

export default RecentWork;